/* eslint no-bitwise: "off" */
/* eslint no-nested-ternary: "off" */

import { DefaultTheme } from 'styled-components'
import { presetPalettes, presetPrimaryColors } from '@ant-design/colors'

// some options may be initialized in the "croco.config.js"
// these options are marked with comments -> "//craco.config"
// please make same changes on craco.config.js

export const colors = {
  primary: '#1890ff', // craco.config
  primaryLight: '#91d5ff',
  primaryFaded: '#e6f7ff',
  secondary: '#273142',
  background: '#ffffff',
  sider: '#f2f5f9',

  blue: presetPrimaryColors.blue,
  cyan: presetPrimaryColors.cyan,
  geekblue: presetPrimaryColors.geekblue,
  gold: presetPrimaryColors.gold,
  green: presetPrimaryColors.green,
  grey: presetPrimaryColors.grey,
  lime: presetPrimaryColors.lime,
  magenta: presetPrimaryColors.magenta,
  orange: presetPrimaryColors.orange,
  purple: presetPrimaryColors.purple,
  red: presetPrimaryColors.red,
  volcano: presetPrimaryColors.volcano,
  yellow: presetPrimaryColors.yellow,

  light: '#fff',
  dark: '#000',
  smoke: '#727272',
  darkGray: '#333333',
  transparent: 'transparent',
  inherit: 'inherit',

  darkTransparent: '#00000070',
  lightTransparent: '#ffffff42',
}
export const palettes = {
  blue: presetPalettes.blue,
  cyan: presetPalettes.cyan,
  geekblue: presetPalettes.geekblue,
  gold: presetPalettes.gold,
  green: presetPalettes.green,
  grey: presetPalettes.grey,
  lime: presetPalettes.lime,
  magenta: presetPalettes.magenta,
  orange: presetPalettes.orange,
  purple: presetPalettes.purple,
  red: presetPalettes.red,
  volcano: presetPalettes.volcano,
  yellow: presetPalettes.yellow,
}
const rainbow = [
  colors.red,
  colors.volcano,
  colors.yellow,
  colors.green,
  colors.blue,
  colors.geekblue,
  colors.purple,
]

export type Color = keyof typeof colors

const getThemedColor = (color: Color | undefined, themeObj: DefaultTheme): string => {
  const validColor: Color = color || 'dark'
  return themeObj.colors[validColor]
}
const createAnimation = (duration = 0.3): string => `${duration}s cubic-bezier(.25,.8,.25,1)`

// ** INDEX **
// COLORS
// MAIN
// COMPONENTS
// PAGES
// FUNCTIONS

const theme = {
  // MAIN
  colors,
  palettes,
  rainbow,
  limits: {
    xsMaxSize: 576,
    smMinSize: 576,
    mdMinSize: 768,
    lgMinSize: 992,
    xlMinSize: 1200,
    xxlMinSize: 1600,

    limitedContentWidth: 1425,
  },
  spacing: {
    spacing0: 0,
    spacing4: 4,
    spacing8: 8,
    spacing12: 12,
    spacing16: 16,
    spacing24: 24,
    spacing36: 36,
    spacing48: 48,
  },
  main: {
    contentMaxWidth: 1200,
    borderRadius: 6, // craco.config
    shadow:
      '0 3px 6px -4px rgb(0 0 0 / 12%), 0 6px 16px 0 rgb(0 0 0 / 8%), 0 9px 28px 8px rgb(0 0 0 / 5%)',
    shadowHover:
      '0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 6px 16px 0 rgba(0, 0, 0, 0.08),0 9px 28px 8px rgba(0, 0, 0, 0.05);',
    defaultAnimation: createAnimation(),
  },

  // COMPONENTS
  header: {
    height: 64,
  },

  // FUNCTIONS
  getThemedColor(color: Color | undefined): string {
    return getThemedColor(color, theme)
  },
  createAnimation,
}

export const lightenColor = (color: Color, strength = 0.4): string => {
  // strength 0 - 1
  const themedColor = theme.getThemedColor(color)

  const num = parseInt(themedColor.replace('#', ''), 16)
  const amt = Math.round(2.55 * strength * 100)
  const R = (num >> 16) + amt
  const B = ((num >> 8) & 0x00ff) + amt
  const G = (num & 0x0000ff) + amt
  return `#${(
    0x1000000 +
    (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
    (B < 255 ? (B < 1 ? 0 : B) : 255) * 0x100 +
    (G < 255 ? (G < 1 ? 0 : G) : 255)
  )
    .toString(16)
    .slice(1)}`
}

export default theme
export type Theme = typeof theme
